import { render } from "./TableSceleton.vue?vue&type=template&id=05f7c798"
import script from "./TableSceleton.vue?vue&type=script&lang=js"
export * from "./TableSceleton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__